(function ($) {

  let updateProgressbar = function (ele, nextSlide) {
    let index = parseInt(nextSlide) + 1;
    let totalSlide = 3;
    let progress = (index / totalSlide) * 100;
    ele.find('.slider-progress').width(progress + '%');
    ele.find('.slider-current-index').html(index < 10 ? '0' + index : index);
    ele.find('.slide-title').removeClass('active');
    ele.find('.group').eq(index).find('.slide-title').eq(0).addClass('active').trigger('click');
    ele.find('.slides-title-list-mobile .slide-title').eq(index - 1).addClass('active');
    console.log(index);
  };

  if ($('.section--academic-teaching-units-slider').length) {

    let _viewWidth = window.innerWidth;

    $('.section--academic-teaching-units-slider').each(function () {

      let _this = $(this);
      let _mainSlideContainer = _this.find('.slides-image-wrapper');
      let _sideTitleContainer = _this.find('.slide-title-wrapper .slides-title-list-desktop');
      let _slideMobileTitleContainer = _this.find('.slide-title-wrapper .slides-title-list-mobile')

      let _mainSlide = _mainSlideContainer.not('.slick-initialized').slick({
        arrows: false,
        dots: false,
        slidesToShow: 1,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        touchThreshold: false,
        speed: 500,
        fade: true,
        adaptiveHeight: true,
        cssEase: 'linear'
      });
      let _sideTitle = _sideTitleContainer.not('.slick-initialized').slick({
        arrows: false,
        dots: false,
      });

      _sideTitle.on('afterChange', function (event, slick, nextSlide) {
        updateProgressbar(_this, nextSlide);
      });

      _mainSlide.on('afterChange', function (event, slick, nextSlide) {
        if (_viewWidth < 992) {
          let _SL = 0;
          for (let i = 0; i < nextSlide; i++) {
            _SL += _this.find('.slides-title-list-mobile .slide-title').eq(i).outerWidth();
          }
          _this.find('.slides-title-list-mobile').scrollLeft(_SL);
        }
      });

      _sideTitle.find('.slide-title').click(function (e) {
        e.preventDefault();
        _sideTitle.find('.slide-title').removeClass('active');
        $(this).addClass('active');
        _mainSlide.slick('slickGoTo', $(this).attr('data-id'));
      });

      _slideMobileTitleContainer.find('.slide-title').click(function (e) {
        e.preventDefault();
        _slideMobileTitleContainer.find('.slide-title').removeClass('active');
        $(this).addClass('active');
        _mainSlide.slick('slickGoTo', $(this).attr('data-id'));
      });

      _this.find('.slider-next').click(function (e) {
        e.preventDefault();
        _sideTitle.slick('slickNext');
      });

      _this.find('.slider-prev').click(function (e) {
        e.preventDefault();
        _sideTitle.slick('slickPrev');
      });

      $(window).resize(function () {
        _viewWidth = window.innerWidth;
        if(_viewWidth == 993) {
          _sideTitle[0].slick.refresh();
        }
      });
    });
  }

  if($('.section--academic-teaching-units').length) {

    let $grid = jQuery('.card-list').masonry({
      itemSelector: '.card--simple-vertical-card-button',
    });

    $grid.imagesLoaded().progress( function() {
      $grid.masonry('layout');
      AOS.refresh();
    });
  }

})(jQuery);
